define('Components/ScrollPopinWidget/js/views/ScrollPopinWidgetInstanceView',['jquery','app','WidgetInstanceView',
        'template!Components/ScrollPopinWidget/templates/scroll-popin'],
    function($,app,WidgetInstanceView, ScrollPopinTemplate){
    return WidgetInstanceView.extend({
        name:'ScrollPopinWidgetInstanceView',
        events: {
            'click .scroll-popin': 'slideToFirstStrate'
        },
        slideToFirstStrate: function() {
            var     header = $('[data-widget=PageHeaderWidget]').height()
                ,   reinsurence = $('[data-widget=ReinsuranceWidget]').height()
                ,   firstStratePos = header + reinsurence

            $('html').animate({
                scrollTop: firstStratePos + 'px'
            }, 400)
        },
        getTemplate:function(){
            return ScrollPopinTemplate
        },
        afterRender:function(){
            var self = this, timeout,
                btn = self.$('.scroll-popin');
            function toggle(state){
                btn.toggleClass('hover',state);
                clearTimeout(timeout);
            }
            btn.hover(function(e){
                toggle(e.type==='mouseenter');
            })
            var suggestion_delay = parseInt(self.model.p('suggestion_delay',10000));
            if(suggestion_delay>0){
                timeout = setTimeout(function(){
                    toggle(true);
                },suggestion_delay);
            }
            self.listenTo(app,'change:scrollTop',self.onScroll);
        },
        onScroll: function(){
            var view = this,
                el = view.$('.scroll-popin'),
                hide = app.get('scrollTop') > 300;
            if(hide){
                el.toggleClass('hover',false);
            }
            el.toggleClass('hidden',hide)
        }
    })
});
